import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { Box, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';

import { AssessmentFeedback } from '../../interview/components/assessment-feedback';
import { InterviewStatusPage } from '../../interview/components/interview-state-views';

export const AssessmentComplete = ({
  assessmentId,
}: {
  assessmentId: string;
}) => {
  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      minHeight='100vh'
    >
      <Box textAlign='center' px={3}>
        <AssessmentFeedback
          assessmentId={assessmentId}
          copy={{
            title: 'Thanks for taking the assessment',
            ratingLabel: 'Rate your experience',
            commentLabel: 'Describe your experience',
          }}
        />
      </Box>
    </Box>
  );
};

export const AssessmentLoading = () => (
  <Box
    sx={{
      opacity: 0,
      animation: 'fadeIn 1s ease-in forwards',
      animationDelay: '2s',
      '@keyframes fadeIn': {
        to: {
          opacity: 1,
        },
      },
    }}
  >
    <InterviewStatusPage
      icon={<CircularProgress />}
      title='Loading assessment'
      description='Please wait while we prepare your assessment...'
    />
  </Box>
);

export const AssessmentNotFound = () => (
  <InterviewStatusPage
    icon={
      <motion.div
        animate={{ rotate: [0, 10, -10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        style={{ display: 'inline-block' }}
      >
        <SentimentDissatisfiedIcon
          sx={{
            fontSize: 64,
            color: 'warning.main',
          }}
        />
      </motion.div>
    }
    title='Assessment not found'
    description="The assessment you're looking for doesn't exist or has been removed."
  />
);

export const AssessmentErrorLoading = () => (
  <InterviewStatusPage
    icon={
      <ErrorOutlineIcon
        sx={{
          width: 64,
          height: 64,
          color: 'error.main',
        }}
      />
    }
    title='Error loading assessment'
    description='We encountered an error while loading your assessment. Please try again.'
    showTryAgainButton
  />
);
